import {
  Tooltip,
  useToken,
  Card,
  CardHeader,
  CardBody,
  Heading,
  Flex,
  HStack,
  IconButton,
} from "@chakra-ui/react";
import Icon from "../../UI/Icon";

type Props = {
  children: React.ReactNode;
  title: string;
  onReload: () => void;
  helpText?: string;
  isRefetching?: boolean;
  isLoading?: boolean;
  isMinimized?: boolean;
  canMinimize?: boolean;
  toggleMinimize?: () => void;
};

const DashboardWidget = ({
  children,
  title,
  helpText,
  isRefetching = false,
  isLoading = false,
  isMinimized = false,
  canMinimize = false,
  toggleMinimize,
  onReload,
}: Props) => {
  const helpIconColor = useToken("colors", "blackAlpha.600");

  return (
    <Card variant="outline" h="full">
      <CardHeader>
        <Flex w="full" justify="space-between">
          <Heading size="md">{title}</Heading>
          <HStack>
            <Tooltip shouldWrapChildren label="Reload">
              <IconButton
                isDisabled={isLoading}
                isLoading={isRefetching}
                variant="ghost"
                aria-label="Refresh widget"
                onClick={onReload}
                size="sm"
                icon={<Icon name="RefreshCw" />}
              />
            </Tooltip>
            {helpText && (
              <Tooltip shouldWrapChildren label={helpText}>
                <Icon color={helpIconColor} name="HelpCircle" />
              </Tooltip>
            )}
            {canMinimize && toggleMinimize && (
              <Tooltip
                shouldWrapChildren
                label={isMinimized ? "Maximize" : "Minimize"}>
                <IconButton
                  aria-label="minimise"
                  onClick={toggleMinimize}
                  size="sm"
                  variant="ghost"
                  icon={
                    isMinimized ? (
                      <Icon name="Maximize2" />
                    ) : (
                      <Icon name="Minimize2" />
                    )
                  }
                />
              </Tooltip>
            )}
          </HStack>
        </Flex>
      </CardHeader>
      <CardBody>{children}</CardBody>
    </Card>
  );
};

export default DashboardWidget;
